export var PhotoTagEntityType;
(function (PhotoTagEntityType) {
    PhotoTagEntityType["EVENT"] = "EVENT";
    PhotoTagEntityType["VENUE"] = "VENUE";
    PhotoTagEntityType["VENDOR"] = "VENDOR";
    PhotoTagEntityType["USER"] = "USER";
    /**
     * The kind of occasion the photograph shows — a Wedding, a Shabbaton — taken
     * from the list in Settings → Event Types and tagged straight onto the photo.
     *
     * This is what files a photograph into a section of the public gallery. It is
     * separate from `EVENT` on purpose: a photographer's set from a wedding the
     * office never entered has no Event to point at, and creating one just to
     * label pictures is a chore nobody will keep up. A photo tagged to an Event
     * still takes that event's type when it carries no type tag of its own.
     */
    PhotoTagEntityType["EVENT_TYPE"] = "EVENT_TYPE";
})(PhotoTagEntityType || (PhotoTagEntityType = {}));
//# sourceMappingURL=photo.js.map